// extracted by mini-css-extract-plugin
module.exports = {"grid":"collection-filterable-grid_grid__CZML5","double":"collection-filterable-grid_double__E2Sbp"};